import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { automationApi, type AIAgent } from '../../api/automation';
import { AIAgentLibraryPanel } from '../../components/automationstudio/AIAgentLibraryPanel';

export function AgentConsolePage() {
  const [agents, setAgents] = useState<AIAgent[]>([]);
  const [name, setName] = useState('');
  const [type, setType] = useState('custom');
  const [error, setError] = useState('');

  const load = useCallback(() => {
    void automationApi.listAgents().then((r) => setAgents(r.agents ?? [])).catch((e) => setError(String(e)));
  }, []);

  useEffect(() => { load(); }, [load]);

  const create = async () => {
    if (!name) return;
    try {
      await automationApi.createAgent({ name, type, capabilities: ['analyze'] });
      setName('');
      load();
    } catch (e) {
      setError(String(e));
    }
  };

  const panelAgents = agents.map((a) => ({
    name: a.name,
    type: a.type,
    status: a.active ? 'active' : 'paused',
    tasks: a.capabilities?.length ?? 0,
    success: a.active ? 95 : 0,
  }));

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">AI Agent Console</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">Agent registry, skills, delegation and monitoring.</p>
        </div>
        <Link to="/automation" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Automation Hub</Link>
      </div>
      <div className="mt-6 flex gap-2">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Agent name" className="flex-1 rounded-lg border px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-900" />
        <input value={type} onChange={(e) => setType(e.target.value)} placeholder="Type" className="w-32 rounded-lg border px-3 py-2 text-sm dark:border-slate-700 dark:bg-slate-900" />
        <button onClick={create} className="rounded-lg bg-brand-600 px-4 py-2 text-sm text-white hover:bg-brand-700">Register</button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <div className="mt-6">
        <AIAgentLibraryPanel agents={panelAgents} />
      </div>
    </div>
  );
}
